import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../api/firebase";
import { get, ref } from "firebase/database";

export default function ShortLinkRedirect() {
  const { shortCode } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!db) {
        setErr("Service is not available right now.");
        return;
      }
      try {
        const snap = await get(ref(db, `short_links/${shortCode}`));
        if (cancelled) return;
        const row = snap.val();
        if (!row?.giftkartCategoryId || !row?.giftKey) {
          setErr("This short link is invalid or expired.");
          return;
        }
        navigate(`/${row.giftkartCategoryId}/${row.giftKey}`, { replace: true });
      } catch (e) {
        setErr(e?.message || "Could not open this card link.");
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [navigate, shortCode]);

  return (
    <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: "2rem" }}>
      {err ? <p style={{ color: "#b91c1c" }}>{err}</p> : <p>Opening your card…</p>}
    </div>
  );
}
